module.exports = __webpack_public_path__ + "static/media/buzzer.37b30ad2.mp3";